import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';

import { headerClass, columns } from './HistoryEntryColumn.less';

const HistoryEntryColumn = ({ header, children, smallScaling = true }) => (
  <Col xs={smallScaling} sm>
    <Row middle="xs" className={headerClass}>
      <Col xs>{header}</Col>
    </Row>
    <div className={columns}>{children}</div>
  </Col>
);

HistoryEntryColumn.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node,
  smallScaling: PropTypes.number,
};

export default HistoryEntryColumn;
